import Chat from './Chat.vue';
import MessagingHeader from './MessagingHeader.vue';
import moduleId from './moduleId';

class MessagingRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/messaging',
        name: moduleType,
        meta: { moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: true ,   transitionName: 'slideY'},
        // dynamic load with tree-shaking: However, pwa needs to handle this specific route
        // component: () => import('@/modules/document/index.vue'),
        // header: () => import('@/modules/document/header.vue'),
        components: { default: Chat, header: MessagingHeader },
        // components: { default: Messaging, header: MessagingHeader },
      },
    ];
  };
}
const routeHandler = new MessagingRouteHandler();
export default routeHandler;
